// Общие действия при прокрутке страницы.

import buttonUp from './buttonUp';
import onlineOffice from './onlineOffice';
import scrollSpy from './scrollSpy';

/**
 * Предыдущее значение по Y
 */
let prevPageY: number = 0;

/**
 * Общие действия при прокрутке страницы.
 */
function main(): void
{
	const scrollWithBtnUp = buttonUp();
	const scrollWithBanner = onlineOffice();
	const scrollWithScrollSpy = scrollSpy();
	
	const onWindowScroll = (): void =>
	{
		const pageY = window.pageYOffset;
		const directionDown = ( prevPageY <= pageY );
		
		scrollWithBtnUp( directionDown, pageY );
		scrollWithBanner( pageY );
		scrollWithScrollSpy( pageY );
		
		prevPageY = pageY;
	};
	
	window.addEventListener( 'scroll', onWindowScroll );
	onWindowScroll();
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/Scroll/index.ts